document.addEventListener("DOMContentLoaded", function() {
  const faqSection = document.querySelector("section#tabs-faq");
  if (!faqSection) return;

  const hash = window.location.hash.replace("#", "").trim();
  if (!hash) return;

  const targetBtn = faqSection.querySelector(`[data-anchor="${hash}"]`);
  if (!targetBtn) return;

  // Click the tab / button
  targetBtn.click();

  // Scroll *after* UI reaction (ensure content opened)
  setTimeout(() => {
    const rect = targetBtn.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Offsets
    const offset = window.matchMedia("(max-width: 768px)").matches ? 50 : 350;

    // Smooth scroll with offset
    window.scrollTo({
      top: rect.top + scrollTop - offset,
      behavior: "smooth",
    });

  }, 200);
});








